export const cacheHeaders={
    'pragma': 'no-cache',
    'cache-control': 'no-cache'
}

export const basePath = 'https://apil.breezereview.com/api/';